
import Data from "./Data/Data.json";

const API_BASE_URL = Data.ApiUrl.ApiBaseUrl;
//REACT_APP_API_BASE_URL=http://localhost:58146/api
export const apiEndpoints = {
  login: `${API_BASE_URL}/auth/login`,
  users: `${API_BASE_URL}/Utilisateurs`,
  bureaux: `${API_BASE_URL}/Bureau`,
  agence: `${API_BASE_URL}/Agence`,
  pays: `${API_BASE_URL}/Pays`,
  ville: `${API_BASE_URL}/ville`,
  devise: `${API_BASE_URL}/devises`,
  groupe: `${API_BASE_URL}/groupesUsers`,
  plancompta: `${API_BASE_URL}/planscompta`,
  client: `${API_BASE_URL}/clients`,
  compte: `${API_BASE_URL}/comptes`,
  banque: `${API_BASE_URL}/banques`,
  coupuredevise: `${API_BASE_URL}/coupuresdevises`,
  menu: `${API_BASE_URL}/Menu`,
  caisse: `${API_BASE_URL}/Caisse`,
  journal: `${API_BASE_URL}/Journal`,
  commandedevise: `${API_BASE_URL}/CommandesDevises`,
  codecommission: `${API_BASE_URL}/Commissions`,
  simulationachatvente: `${API_BASE_URL}/SimulationAchatVente`,
  coupuredevise2: `${API_BASE_URL}/CoupureDevise2`,
  histocompte: `${API_BASE_URL}/Histocompte`,
  histoopejour: `${API_BASE_URL}/Histoopejour`,
  histoversementretrait: `${API_BASE_URL}/HistoVersementRetrait`,
  histoachatvente: `${API_BASE_URL}/HistoAchatVente`,
  histoopecompta: `${API_BASE_URL}/HistOpeCompta`,
  billetagecaisse: `${API_BASE_URL}/BilletageCaisse`,
  billetagedevise: `${API_BASE_URL}/BilletageDevise`,
  receptiondevise: `${API_BASE_URL}/ReceptionDevise`,
  achatvente: `${API_BASE_URL}/AchatsVentes`,
  versementretrait: `${API_BASE_URL}/VersementRetrait`,
  brouillardsaisie: `${API_BASE_URL}/brouillardsaisie`,
  datesysteme: `${API_BASE_URL}/datesysteme`,
  commission: `${API_BASE_URL}/commissions`,
  getfield:`${API_BASE_URL}/GetField`,
  habilitation:`${API_BASE_URL}/Habilitation`,
  formatcompte:`${API_BASE_URL}/Formatcompte`,
  accountgenerator:`${API_BASE_URL}/AccountGenerator`,
  fastReport:`${API_BASE_URL}/FastReport`,
  rapportFinancement:`${API_BASE_URL}/RapportFinancement`,
  ssrscontroller:`${API_BASE_URL}/ssrsreports`,
    lib:`${API_BASE_URL}/lib`,
  moduleBI:`${API_BASE_URL}/ModuleBI`,
  //reportscontrollertest:`${API_BASE_URL}/ReportsControllerTest`,
   
  
};